// cache results
const cache = new Map();

/**
 * Fetch paginated content from ACF blocks with data-load-more-* attributes
 */
export const loadMore = () => {
	const paginatedContent = document.querySelectorAll('[data-load-more-id]');

	if (!paginatedContent.length) return;

	const url = window.location.href.split('?')[0];

	paginatedContent.forEach((block) => {
		const button = block.querySelector('[data-load-more-button');
		if (button) {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();

				fetchNextPage(e.target.href, block);
			});
		}

		const filters = block.querySelectorAll('[data-load-more-filter]');
		if (filters) {
			filters.forEach((filter) => {
				// if filter is select element
				if (filter.tagName === 'SELECT') {

					// set initial filter widths
					const span = document.createElement('span');
					// set span text to selected option
					span.innerText = filter.options[0].text;
					document.body.appendChild(span);
					// set width of select to width of span
					filter.style.width = `${span.offsetWidth + 60}px`;
					// remove span
					span.remove();

					filter.addEventListener('change', (e) => {
						e.preventDefault();
						e.stopPropagation();

						// console.log('change');

						const span = document.createElement('span');
						// set span text to selected option
						span.innerText = e.target.options[e.target.selectedIndex].text;
						document.body.appendChild(span);
						// set width of select to width of span
						const offset = ( e.target.getAttribute('name') === 'tag' ? 70 : 50 );
						e.target.style.width = `${span.offsetWidth + offset}px`;
						// remove span
						span.remove();

						// href = url + filter=value
						//const href = `${url}?${e.target.name}=${e.target.value}`;

						// href = url + the name and value of each [data-load-more-filter]
						//console.log(url);
						// get url param lang value
						const urlParams = new URLSearchParams(window.location.search);
						const lang = urlParams.get('lang');
						let href = '';
						// console.log(lang);

						if (lang != '') {
							href = `${url}?lang=${lang}`;
						} else {
							href = `${url}?`;
						}
						filters.forEach((f) => {
							href += `&${f.name}=${f.value}`;
						});
						// console.log(href);

						// filters.forEach((f) => {
						// 	href += `&${f.name}=${f.value}`;
						// });

						fetchNextPage(href, block, true);
					});
				} else {
					// button filter
					filter.addEventListener('click', (e) => {
						e.preventDefault();
						e.stopPropagation();

						// toggle active class
						filters.forEach((f) => {
							if (f !== filter) f.classList.remove('active');
							else f.classList.toggle('active');
						});

						// if filter is active, fetch new results, else reset
						const href = filter.classList.contains('active') ? e.target.href : url;

						fetchNextPage(href, block, true, false);
					});
				}
			});
		}

		// set initial page cache
		const id = block.getAttribute('data-load-more-id');
		const items = block.querySelectorAll('[data-load-more-list] > *');
		const nextPageLink = button?.href;
		const key = `${id}-${url}`;

		cache.set(key, { items, nextPageLink });
	});
};

/** Parse html string into dom nodes
 * @param {string} html
 */
const parse = (html) => {
	const doc = document.createElement('html');
	doc.innerHTML = html;
	return doc.lastChild;
};

/**
 * Fetch next page of paginated or filtered content
 * @param {Event} event
 * @param {HTMLElement} block
 * @param {boolean} isFilter
 * @param {boolean} useCache
 */
async function fetchNextPage(url, block, isFilter = false, useCache = true) {
	if (!url) return;

	const id = block.getAttribute('data-load-more-id');
	const list = block.querySelector('[data-load-more-list]');
	const button = block.querySelector('[data-load-more-button]');

	let items, nextPageLink;

	const key = `${id}-${url}`;

	// check cache
	if (useCache && cache.has(key)) {
		({ items, nextPageLink } = cache.get(key));
	} else {
		// fetch html for next page from link's href
		try {
			const html = await fetch(url).then((rez) => rez.text());
			const fakeDom = parse(html);
			const parent = fakeDom.querySelector(`[data-load-more-id=${id}]`);

			if (parent) {
				items = parent.querySelectorAll('[data-load-more-list] > *');
				nextPageLink = parent.querySelector('[data-load-more-button]')?.href;

				// cache result
				cache.set(key, { items, nextPageLink });
			}
		} catch (err) {}
	}

	if (items.length > 0) {
		if (isFilter) list.innerHTML = '';

		items.forEach((item, i) => {
			list.appendChild(item);

			if (i === 0) {
				item.scrollIntoView({
					behavior: 'smooth',
					block: 'nearest',
				});
			}
		});
	}

	// update pagination link
	if (nextPageLink) {
		button.href = nextPageLink;
		button.style.display = '';
	} else {
		button.style.display = 'none';
	}
}
